import { takeEvery, put, call } from 'redux-saga/effects';
import { npcLogConstant } from 'src/redux/actions/constant';
import npcLogService from 'src/services/apiServices/npcLogService/npcLogService';

function* getNpcTeamEntries(action: any): any {
  try {
    yield put({ type: npcLogConstant.GET_NPC_TEAM_ENTRIES_LOADER });
    const response = yield call(npcLogService.getTeamEntries, action.payload);
    if (response?.status === 200) {
      yield put({ type: npcLogConstant.GET_NPC_TEAM_ENTRIES_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: npcLogConstant.GET_NPC_TEAM_ENTRIES_FAILURE, payload: error });
  }
}

function* getNpcTeamEntriesSaga() {
  yield takeEvery(npcLogConstant.GET_NPC_TEAM_ENTRIES_REQUEST, getNpcTeamEntries);
}

export default getNpcTeamEntriesSaga;
